export const baseUrl = "https://exotic.supagrow.in";

export const getHomePage = "api/homepageapi";
export const getAboutPage = "api/aboutpageapi";
export const getAmenitiesPage = "api/gallery";
export const getNewsCategory ="api/getnewscategory";
export const getNews = "api/getnews";
export const newsDetail = "api/newsdetails";
export const getProject = "api/getproject";
export const projectDetail='api/projectdetails';
export const locationPage = "api/";
export const storeDomesticContact = "api/storecontactapi";
export const storeInternationalContact = "api/storeicontactapi";
export const footerEndPoint = "api/footer";
export const projectCategory = "api/getprojectcategory";
export const contactPage="api/contactpageapi"
